import * as types from '../constants/action-types';
import { filter } from 'lodash';

const initialAddressState = { isPosting: false, isFetching: false, postError: null,
  fetchError: null, error: null, updateError: null, hasFetched: false }

const initialState = {
  vatAddress: initialAddressState,
  billingAddress: initialAddressState
};

export default function fee_profile (state = initialState, action) {
  const { type, data, postError, fetchError, updateError } = action;

  switch (type) {
  case types.BILLING_CREATE_REQUEST:
    return { ...state, billingAddress: { ...state.billingAddress, postError: null, isPosting: true } };

  case types.BILLING_CREATE_SUCCESS:
    return { ...state, billingAddress: { ...state.billingAddress, isPosting: false } };

  case types.BILLING_CREATE_FAILURE:
    return { ...state, billingAddress: { ...state.billingAddress, postError, isPosting: false } };

  case types.BILLING_FETCH_REQUEST:
    return { ...state, billingAddress: { ...state.billingAddress, isFetching: true } };

  case types.BILLING_FETCH_SUCCESS:
    return { ...state, billingAddress: { ...state.billingAddress, data: data, fetchError: null, isFetching: false, hasFetched: true, hasPosted: false } };

  case types.BILLING_FETCH_FAILURE:
    return { ...state, billingAddress: { ...state.billingAddress, fetchError, isFetching: false, hasFetched: true } };

  case types.BILLING_UPDATE_REQUEST:
    return { ...state, billingAddress: { ...state.billingAddress, updateError: null, isPosting: true } };

  case types.BILLING_UPDATE_SUCCESS:
    return { ...state, billingAddress: { ...state.billingAddress, isPosting: false, hasPosted: true } };

  case types.BILLING_UPDATE_FAILURE:
    return { ...state, billingAddress: { ...state.billingAddress, updateError, isPosting: false, hasPosted: false } };

  // Keep `data` and `hasFetched`, as billingAddress does above: readers treat
  // `vatAddress.data` as the fetched list, and storing the single profile the
  // API echoes back there blanks the tax pages. The list waits for a re-fetch.
  case types.VAT_CREATE_REQUEST:
    return { ...state, vatAddress: { ...state.vatAddress, error: null, isPosting: true }};

  case types.VAT_CREATE_SUCCESS:
    return { ...state, vatAddress: { ...state.vatAddress, error: null, isPosting: false }};

  case types.VAT_CREATE_FAILURE:
    return { ...state, vatAddress: { ...state.vatAddress, error: postError, isPosting: false }};

  case types.VAT_UPDATE_REQUEST:
    return { ...state, vatAddress: { ...state.vatAddress, error: null, isPosting: true } };

  case types.VAT_UPDATE_SUCCESS:
    return { ...state, vatAddress: { ...state.vatAddress, error: null, isPosting: false } };

  case types.VAT_UPDATE_FAILURE:
    return { ...state, vatAddress: { ...state.vatAddress, error: updateError, isPosting: false } };

  case types.VAT_REMOVE_REQUEST:
    return { ...state, vatAddress: { ...state.vatAddress, error: null, isPosting: true } };

  case types.VAT_REMOVE_SUCCESS:
    return { ...state, vatAddress: { ...state.vatAddress, error: null, isPosting: false } };

  case types.VAT_REMOVE_FAILURE:
    return { ...state, vatAddress: { ...state.vatAddress, error: updateError, isPosting: false } };

  case types.FEE_PROFILES_FETCH_REQUEST:
    return { ...state,
      billingAddress: { isFetching: true },
      vatAddress: { isFetching: true }
    }

  case types.FEE_PROFILES_FETCH_SUCCESS: {
    const billingAddress = filter(data, { type: 'BILLING' });
    const vatAddress = filter(data, { type: 'VAT' });

    return { ...state,
      billingAddress: { data: billingAddress, isFetching: false, hasFetched: true },
      vatAddress: { data: vatAddress, isFetching: false, hasFetched: true }
    };
  }

  case types.FEE_PROFILES_FETCH_FAILURE: {
    return { ...state,
      error: fetchError,
      billingAddress: { fetchError, isFetching: false, hasFetched: true },
      vatAddress: { fetchError, isFetching: false, hasFetched: true }
    }
  }
  // the fee profile for a particular invoice (could be an old deactivated address)
  case types.FETCH_ADDRESS_BY_ID_REQUEST: {
    return { ...state,
      invoiceFeeProfile: { isFetching: true }
    }
  }

  case types.FETCH_ADDRESS_BY_ID_SUCCESS: {
    return { ...state, invoiceFeeProfile: { data: data, isFetching: false, hasFetched: true } };
  }

  case types.FETCH_ADDRESS_BY_ID_FAILURE: {
    return { ...state, invoiceFeeProfile: { fetchError, isFetching: false, hasFetched: true } };
  }

  default:
    return state;
  }
}
